<div class="form-badge" [ngClass]="Color ? 'form-badge--' + Color : null">
  <fa-icon *ngIf="Icon" [icon]="Icon"></fa-icon>
</div>
